var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketsmartIconBasicReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.81 78.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffcd00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "marketsmart-logo-basic-reverse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "matrix(1, 0, 0, 1, -219.039978, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 258.43,
    cy: 39.39,
    r: 39.39
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "matrix(1, 0, 0, 1, -219.002182, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.75,36.89a39.28,39.28,0,0,0-13-26.89A24.51,24.51,0,0,1,288,32a24.21,24.21,0,0,1-11.05,13l-.09,0a30.15,30.15,0,0,0-9.71,8.72c-1,1.32-5.83,7.18-6,7.15l-6.27-1.44-15-3.45s.48-8.36.58-9.71a31.93,31.93,0,0,0-1.77-13.78,5,5,0,0,0-.39-.95l0-.1A23.86,23.86,0,0,1,249.89.86,39.4,39.4,0,0,0,233.67,70c1,.81,2.05,1.58,3.12,2.29a39.4,39.4,0,0,0,43.28,0c1.07-.72,2.12-1.48,3.12-2.29A39.34,39.34,0,0,0,297.75,36.89Zm-53,38.88A5.65,5.65,0,0,1,241,69.71l11,2.61A5.91,5.91,0,0,1,244.78,75.77ZM257.87,70a2.51,2.51,0,0,1-3.07,1.55l-16.1-3.79A2.34,2.34,0,0,1,236.78,65a2.51,2.51,0,0,1,3.07-1.56l16.09,3.8A2.33,2.33,0,0,1,257.87,70Zm1.88-5.42a2.5,2.5,0,0,1-3.06,1.56l-16.1-3.8a2.33,2.33,0,0,1-1.92-2.73A2.49,2.49,0,0,1,241.74,58l16.09,3.79A2.33,2.33,0,0,1,259.75,64.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketsmartIconBasicReverse);
export default __webpack_public_path__ + "static/media/marketsmart-icon-basic-reverse.2a8398f69740f6cea7204ef1a417e361.svg";
export { ForwardRef as ReactComponent };